import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import moment from 'moment';
import {stringFormat} from '@ey/utils';
import {currentResource} from '../../../../../../../src/util/utils';
import {useEngagementId, useDocumentId} from '../../../../../../../src/util/customHooks';
import {createSample, updateSampleItem} from '../../../../../../../src/actions/SampleItems/sampleItemActions';
import {clearErrors} from '../../../../../../actions/erroractions';
import Utility from '../../../../../../../src/util/utilityfunctions';
import CreateEditSampleModal from './CreateEditSampleModal';
import {sampleItemTypes} from '../../../../../../../src/util/uiconstants';

const CreateEditSampleWrapper = ({
	isCreate = false,
	isEdit = false,
	showModal,
	onHideModal,
	sampleListId,
	sampleItemId,
	sampleName,
	sampleDate,
	reloadList
}) => {
	const sampleLabels = currentResource.sampleList;
	const [isLoading, setIsLoading] = useState(false);
	const [inputFields, setInputFields] = useState({
		description: isEdit ? sampleName : '',
		sampleDate: isEdit ? sampleDate : null,
		hasValidation: false
	});
	const dispatch = useDispatch();
	const engagementId = useEngagementId();
	const documentId = useDocumentId();

	useEffect(() => {
		return () => {
			dispatch(clearErrors());
			isCreate && reloadList();
		};
	}, []);

	const checkValidation = () => {
		if (
			inputFields.description.trim().length > 500 ||
			inputFields.description.trim() === '' ||
			!inputFields.sampleDate ||
			inputFields.sampleDate === null
		) {
			setInputFields({
				...inputFields,
				hasValidation: true
			});
			return false;
		}
		return true;
	};

	const resetFields = () => {
		setInputFields({
			description: '',
			sampleDate: null,
			hasValidation: false
		});
	};

	const payload = {
		sampleItemName: inputFields.description,
		sampleItemDate: moment(inputFields.sampleDate).format('YYYY-MM-DD'),
		hostDocumentId: documentId,
		sampleItemType: sampleItemTypes.normalSample
	};

	const saveChanges = (saveUrl, createAnother = false) => {
		if (checkValidation()) {
			setIsLoading(true);
			dispatch(saveUrl)
				.then(() => {
					setIsLoading(false);
					createAnother ? resetFields() : onHideModal();
				})
				.catch(() => {
					setIsLoading(false);
				});
		}
	};

	const saveAndCreateAnother = (saveUrl) => {
		saveChanges(saveUrl, true);
	};

	return (
		<>
			{isCreate && (
				<CreateEditSampleModal
					showModal={showModal}
					modalTitle={sampleLabels.newSample}
					isLoading={isLoading}
					onCloseModal={onHideModal}
					saveAndClose={() => saveChanges(createSample(engagementId, sampleListId, payload))}
					saveAndCreateAnother={() => saveAndCreateAnother(createSample(engagementId, sampleListId, payload))}
					modalDescription={Utility.createRichTextElement(
						stringFormat(
							sampleLabels.createSampleModalDescription,
							sampleLabels.saveAndCloseForHeader,
							sampleLabels.saveAndCreateAnotherHeader
						)
					)}
					sampleLabels={sampleLabels}
					inputFields={inputFields}
					setInputFields={setInputFields}
					showSaveAndCreateNewButton={true}
					saveAndCloseTitle={sampleLabels.saveAndClose}
					saveAndCreateAnotherTitle={sampleLabels.saveAndCreateAnother}
				/>
			)}
			{isEdit && (
				<CreateEditSampleModal
					showModal={showModal}
					modalTitle={sampleLabels.editSample}
					isLoading={isLoading}
					onCloseModal={onHideModal}
					saveAndClose={() => saveChanges(updateSampleItem(engagementId, sampleListId, sampleItemId, payload))}
					modalDescription={Utility.createRichTextElement(
						stringFormat(sampleLabels.editSampleDescription, sampleLabels.editSampleSave)
					)}
					sampleLabels={sampleLabels}
					inputFields={inputFields}
					setInputFields={setInputFields}
					saveAndCloseTitle={sampleLabels.editSampleSave}
				/>
			)}
		</>
	);
};

export default CreateEditSampleWrapper;
